<template>
  <ContentBlock
    :title="configData.Title"
    :title-extension="configData.TitleExtension"
    :text="configData.Text"
    :link-button-text="configData.LinkButtonText"
    :link-button-url="configData.LinkButtonUrl"
    :link-button-size="configData.LinkButtonSize"
    :image-url="configData.ImageUrl"
    :image-alt="configData.ImageAlt"
    :label-color="configData.LabelColor"
    :label-text="configData.LabelText"
    :layout-row="configData.LayoutRow"
  />
</template>

<script lang="ts" setup>
import type { ButtonSize } from '../AppButton.vue';
interface Props {
  configData: {
    Title?: string;
    TitleExtension?: string;
    Text?: string;
    LinkButtonText?: string;
    LinkButtonUrl?: string;
    LinkButtonSize?: ButtonSize;
    ImageUrl?: string;
    ImageAlt?: string;
    LabelColor?: string;
    LabelText?: string;
    LayoutRow?: boolean;
  };
}

defineProps<Props>();
</script>

<style scoped></style>
